import { useForm } from 'react-typed-form';

import { Api, useApiFormSubmit } from '../../../api';
import { Modal, Stack } from '../../../components';
import { Style } from '../../../constants';
import {
  FieldTextRequired,
  SubmitButton,
  createFormValidator,
} from '../../../form';

type Props = Readonly<{
  ticket: Api.Ticket.V_Detail;
  onClose: () => void;
  invalidate: () => unknown;
}>;

export default function EditTitleModal({ ticket, onClose, invalidate }: Props) {
  const form = useForm<Api.Ticket.W_Update_partial>({
    defaultValues: { title: ticket.title },
    validator: createFormValidator({
      title: { strictPresence: { message: '^Please enter a title' } },
    }),
    onSubmit: useApiFormSubmit('PUT', `/tickets/${ticket.id}`, {
      onSuccess: () => {
        onClose();
        invalidate();
      },
    }),
  });

  return (
    <Modal title="Edit ticket title" onClose={onClose} fullScreenOnMobile>
      <Stack padH={1.5} padV={1.5} gap={1.5}>
        <FieldTextRequired
          field={form.getField('title')}
          label="Ticket title"
          autoFocus
        />
      </Stack>

      {/* Footer */}
      <Stack padH padV style={Style.alignEnd}>
        <SubmitButton {...form} />
      </Stack>
    </Modal>
  );
}
